import { jsx } from "react/jsx-runtime";
import { forwardRef } from "react";
export default forwardRef((props, ref) => jsx("svg", {
    viewBox: "0 0 24 24",
    fill: "#707070",
    xmlns: "http://www.w3.org/2000/svg",
    ref,
    ...props,
    dangerouslySetInnerHTML: { __html: '<path d="M6.852 7H4.243c-.73 0-1.33.6-1.33 1.33v7.33c0 .74.6 1.34 1.33 1.34h2.609V7Z" fill="inherit"/> <path d="M19.583 17c.73 0 1.33-.6 1.33-1.33V14h2v-4h-2V8.33c0-.73-.6-1.33-1.33-1.33H6.835v10h12.748Z" fill="#D9D9D9"/>' }
  })
);